import {
  type DescribeElicitation,
  isDescribeElicitation,
  isSearchSelectElicitation,
  isStepperElicitation,
  isTextFieldsElicitation,
  type RenderableElicitation,
  type SearchSelectElicitation,
  type StepperElicitation,
  type TextFieldsElicitation,
} from '~/components/v2/components/workspace/workspace-agent-panel/schemas/elicitation';

export type AskFormElicitation =
  | DescribeElicitation
  | TextFieldsElicitation
  | StepperElicitation
  | SearchSelectElicitation;

/** `UnknownElicitation.type` is `string`, so equality alone won't narrow the union in JSX. */
export const isAskFormElicitationEntry = (
  elicitation: RenderableElicitation | null,
): elicitation is AskFormElicitation =>
  elicitation !== null &&
  (isDescribeElicitation(elicitation) ||
    isTextFieldsElicitation(elicitation) ||
    isStepperElicitation(elicitation) ||
    isSearchSelectElicitation(elicitation));
